import { campaignInventoryOverview } from './campaign-inventory-overview.js';

export function CampaignInventoryOverview({ campaigns, summaries, summaryStatus, listStatus }) {
  const values = campaignInventoryOverview(campaigns, summaries);
  const hasPage = listStatus === 'ready' || campaigns.length > 0;
  const loading = summaryStatus === 'loading' && summaries.size === 0 && campaigns.length > 0;
  const count = (value) => value === null ? '—' : new Intl.NumberFormat().format(value);
  const money = (value) => value === null ? '—' : new Intl.NumberFormat(undefined, {
    style: 'currency', currency: values.currency, minimumFractionDigits: 2, maximumFractionDigits: 2,
  }).format(value);
  const coverage = (availableCount) => availableCount === values.count
    ? values.count + ' campaigns on this page'
    : availableCount + ' of ' + values.count + ' campaigns reporting';
  const items = [
    ['Meta-reported leads', count(values.leads), coverage(values.leadCount)],
    ['Average cost / lead', money(values.costPerLead), values.mixedCurrencies
      ? 'Multiple currencies · see each campaign'
      : 'Spend ÷ leads · ' + values.pairedCount + ' campaigns with both metrics'],
    ['Amount spent', money(values.spend), values.mixedCurrencies
      ? 'Multiple currencies · totals unavailable'
      : coverage(values.spendCount) + (values.currency ? ' · ' + values.currency : '')],
    ['Active campaigns', count(values.active), values.paused + ' paused · ' + values.draftsAndReview + ' drafts & review'],
  ];
  return (
    <section className="bl-campaign-overview" aria-label="Performance of campaigns on this page" aria-busy={loading || listStatus === 'loading'}>
      <div className="bl-campaign-overview-strip">
        {items.map(([label, value, note]) => (
          <div className="bl-campaign-overview-item" key={label}>
            <span className="bl-campaign-overview-label">{label}</span>
            <strong>{!hasPage || (loading && label !== 'Active campaigns') ? '—' : value}</strong>
            <span className="bl-campaign-overview-note">{hasPage ? note : listStatus === 'loading' ? 'Loading campaigns…' : 'Campaign inventory unavailable'}</span>
          </div>
        ))}
      </div>
      {(values.stale || values.partial || summaryStatus === 'error' || summaryStatus === 'loading') && (
        <p className="bl-campaign-overview-state">
          {summaryStatus === 'error' ? summaries.size > 0
            ? 'Refresh failed. Showing the last loaded results.'
            : 'Performance is unavailable. Retry the performance request below.'
            : summaryStatus === 'loading' ? 'Updating performance…'
              : values.stale ? 'Includes stale performance. Check campaign freshness below.'
                : 'Some performance is unavailable. Totals include available results only.'}
        </p>
      )}
    </section>
  );
}
